<template>
  <BaseLinkButton
    :class="sizeClass"
    :data-testid="dataTestId"
    class="tw:font-bold tw:border tw:border-gray-600 tw:text-gray-800 tw:bg-white"
    v-bind="$attrs"
  >
    <slot />
  </BaseLinkButton>
</template>

<script setup>
import { computed } from 'vue'
import BaseLinkButton from './BaseLinkButton.vue'

const props = defineProps({
  size: {
    type: String,
    default: 'big',
  },
  dataTestId: {
    type: String,
    default: '',
  },
})

const sizeClass = computed(() => {
  if (props.size === 'small') return 'tw:px-3 tw:py-0.5 tw:text-xs tw:rounded line-height-150'
  if (props.size === 'medium') return 'box-size-36 tw:px-4 tw:py-2 tw:text-sm tw:rounded-lg line-height-180'
  else return 'box-size-44 tw:px-6 tw:py-2 tw:text-base tw:rounded-lg line-height-260'
})
</script>

<style scoped>
@media (hover: hover) and (pointer: fine) {
  a:hover {
    text-decoration: none;
    background-color: var(--tw-color-gray-600);
    color: var(--tw-color-white);
    border-color: var(--tw-color-gray-600);
  }
}
a:disabled {
  color: var(--tw-color-gray-300);
  border-color: var(--tw-color-gray-300);
}
</style>
